export default "__VITE_ASSET__C6l$0C2d__"